import { NoDataScreen } from './no-data-screen';

export { NoDataScreen };
